<template>
  <div 
    :id="id" 
    class="modal fade" 
    data-backdrop="static" 
    tabindex="-1">
    <div class="bottom modal-dialog modal-full white b-r">
      <div class="row-col">
        <slot name="header-action">
          <a 
            data-dismiss="modal" 
            class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
        </slot>
        <div class="p-a b-b">
          <span class="h5">
            <slot name="header-text"/>
          </span>
        </div>
        <div class="row-row">
          <div class="row-body">
            <div class="row-inner">
              <slot name="body"/>
            </div>
          </div>
        </div>
        <div 
          v-if="! hideFooter" 
          class="p-a b-t text-right">
          <button 
            :disabled="loading" 
            data-dismiss="modal" 
            class="btn btn-fw white">{{ cancelText }}</button>
          <slot name="footer"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },

        cancelText: {
            type: String,
            default: 'Close',
        },

        loading: {
            type: Boolean,
            default: false,
        },
        hideFooter: {
            type: Boolean,
            default: false,
        },
    },

    mounted() {
        this.registerEvents();
    },

    methods: {
        show() {
            $(`#${this.id}`).modal('show');
        },

        hide() {
            $(`#${this.id}`).modal('hide');
        },

        registerEvents() {
            this.$on('show', () => {
                this.show();
            });

            this.$on('hide', () => {
                this.hide();
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/modal-full.vue